import { AnnotationButton } from "components/annotations/AnnotationButton";
import { ReactNode } from "react";
import styles from "../aic.module.css";
import { AitAddRowButton } from "./AitAddRowButton";
import { AitRemoveRowButton } from "./AitRemoveRowButton";
import { AitRowDeletedItemTrafficLight } from "./AitRowDeletedItemTrafficLight";
import { AitRowGroupDeletedItemTrafficLight } from "./AitRowGroupDeletedItemTrafficLight";
import { AitRowTrafficLight } from "./AitRowTrafficLight";
import { AitLocationBodyRow, AitTablePosition } from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowLastCellProps {
  location: AitLocationBodyRow;
}

/**
 * Render the last cell for a body row with row controls and annotations.
 *
 * @param props - Component props
 * @param props.location - The body row location
 */
export const AitRowLastCell = ({ location }: AitRowLastCellProps): ReactNode => {
  const { state } = useTableContext();
  const thisRow = trGetPositionFromLocation(state, location, true).data;
  const showRowTrafficLight = thisRow?.coreTrafficLight === "ChangedUnknown";
  const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";

  return (
    <td
      className={styles.aitCell}
      width="50px"
    >
      {showRowTrafficLight && <AitRowTrafficLight location={location} />}
      {location.row === 0 && !location.isRepeat && (
        <AitRowGroupDeletedItemTrafficLight
          location={{
            position: AitTablePosition.bodyRowGroup,
            tableSection: location.tableSection,
            rowGroup: location.rowGroup,
            rowGroupId: location.rowGroupId,
          }}
        />
      )}
      <AitRowDeletedItemTrafficLight location={location} />
      {!location.isRepeat && (
        <div className={[styles.flexRowStart, styles.aitAieHolder].join(" ")}>
          <div className={styles.aitRowButtons}>
            <AitAddRowButton location={location} />
            <AitRemoveRowButton location={location} />
          </div>
          <AnnotationButton
            buttonId={`${location.position}-row-${location.rowId}-annotation`}
            annotationType="Row"
            annotationLocation={location}
            existingAnnotation={thisRow?.annotation}
            hidden={state?.tlfViewMode.value !== "ANNOTATIONS"}
            showPreview={showAnnotationPreview}
          />
        </div>
      )}
    </td>
  );
};

AitRowLastCell.displayName = "AitRowLastCell";
